<template>
  <div :class="`${pointy ? `${classVariableName}-cursor-pointer` : ''}`">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.68313 12.1321L7.57467 9.35838C7.56378 9.07981 7.66967 8.80933 7.8668 8.6122L15.1186 1.36039C15.3139 1.16513 15.6305 1.16513 15.8257 1.36039L18.647 4.18162C18.8422 4.37688 18.8422 4.69346 18.647 4.88873L11.3952 12.1405C11.198 12.3376 10.9275 12.4435 10.649 12.4326L7.87516 12.3241C7.77084 12.3201 7.68721 12.2364 7.68313 12.1321Z"
        stroke="#211A1E"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M13.0142 3.4502L16.5425 6.97853"
        stroke="#211A1E"
        stroke-width="1.2"
        stroke-linecap="round"
      />
      <path
        d="M9.01006 3H3C1.89543 3 1 3.89543 1 5V17C1 18.1046 1.89543 19 3 19H15C16.1046 19 17 18.1046 17 17V11.0483"
        stroke="#211A1E"
        stroke-width="1.2"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { classVariableName } from "../../utils";

export default defineComponent({
  props: {
    pointy: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      classVariableName: classVariableName,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../../assets/Components.scss";
</style>
